'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { CompanyCard } from '../about/CompanyCard';
interface Partner {
  href: string;
  logo: string | React.ReactNode;
  name: string;
}
interface PartnersCarouselProps {
  partners: Partner[];
  gap?: number; // Gap in pixels, defaults to 32px
}
export const PartnersCarousel: React.FC<PartnersCarouselProps> = t0 => {
  const $ = _c(12);
  const {
    partners,
    gap: t1
  } = t0;
  const gap = t1 === undefined ? 32 : t1;
  const containerRef = useRef(null);
  const [sliderWidth, setSliderWidth] = useState("200%");
  let t2;
  let t3;
  if ($[0] !== gap || $[1] !== partners.length) {
    t2 = () => {
      const updateWidth = () => {
        const containerWidth = containerRef.current?.offsetWidth || window.innerWidth;
        const totalCardsWidth = partners.length * 204;
        const totalGapsWidth = gap * (partners.length + 1);
        const totalWidthNeeded = totalCardsWidth + totalGapsWidth;
        if (containerWidth >= totalWidthNeeded) {
          setSliderWidth("200%");
        } else {
          const widthPercentage = (totalWidthNeeded / containerWidth * 200).toFixed(2) + "%";
          setSliderWidth(widthPercentage);
        }
      };
      updateWidth();
      window.addEventListener("resize", updateWidth);
      return () => {
        window.removeEventListener("resize", updateWidth);
      };
    };
    t3 = [partners.length, gap];
    $[0] = gap;
    $[1] = partners.length;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (partners.length === 0) {
    return null;
  }
  const durationSec = partners.length * 3;
  const t4 = `${durationSec}s`;
  let t5;
  if ($[4] !== sliderWidth || $[5] !== t4) {
    t5 = {
      "--carousel-width": sliderWidth,
      "--carousel-duration": t4
    };
    $[4] = sliderWidth;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[7] !== partners) {
    t7 = partners.concat(partners).map(_temp);
    $[7] = partners;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div ref={containerRef} className="w-full overflow-hidden"><div className="partners-carousel-scroll py-5" style={t6}>{t7}</div></div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
function _temp(partner, index) {
  return <div key={`${partner.name}-${index}`} className="shrink-0"><CompanyCard href={partner.href} logo={partner.logo} name={partner.name} /></div>;
}